import * as React from 'react';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import Select from '@mui/material/Select';
import { styled } from '@mui/material/styles';
import InputBase from '@mui/material/InputBase';
import { Photographer } from './FavoriteImagesPage';

const StyledSelect = styled(InputBase)(({ theme }) => ({
    '& .MuiInputBase-input': {
        zIndex: 0
    },
    '&& .MuiSelect-outlined': {
        margin: 'auto',
        zIndex: 100,
        borderRadius: 4,
        position: 'relative',
        backgroundColor: theme.palette.background.paper,
        border: '1px solid #ced4da',
        fontSize: 14,
        padding: '12px',
        transition: theme.transitions.create(['border-color', 'box-shadow']),
        display: 'flex',
        alignItems: 'center'
    },
    '&:focus': {
        zIndex: 100,
        borderRadius: 4,
        borderColor: '#80bdff',
        boxShadow: '0 0 0 0.2rem rgba(0,123,255,.25)'
    },
    '& .MuiSelect-icon': {
        zIndex: 50,
        width: '24px',
        height: 'auto',
        top: '25%'
    }
}));

type PhotographerSelectFilterProps = {
    handleSelectedPhotographer: (any) => void;
    selectedPhotographer: Photographer | null;
    previousSelectedPhotographer: Photographer | null;
    availablePhotographers: Photographer[];
    defaultOptionLabel: string;
    filterTitleLabel: string;
};

function getDefaultValue(
    selectedPhotographer: Photographer | null,
    previousSelectedPhotographer: Photographer | null,
    defaultOptionLabel: string
): string {
    if (selectedPhotographer) {
        return selectedPhotographer.id.toString();
    }

    if (previousSelectedPhotographer) {
        return previousSelectedPhotographer.id.toString();
    }

    return defaultOptionLabel;
}

const PhotographerSelectFilter = ({
    handleSelectedPhotographer,
    selectedPhotographer,
    previousSelectedPhotographer,
    availablePhotographers,
    defaultOptionLabel,
    filterTitleLabel
}: PhotographerSelectFilterProps) => {
    let defaultValue = getDefaultValue(
        selectedPhotographer,
        previousSelectedPhotographer,
        defaultOptionLabel
    );

    return (
        <FormControl sx={{ width: 240 }}>
            <FormLabel sx={{ fontSize: '12px' }}>{filterTitleLabel}</FormLabel>
            <Select
                variant={'outlined'}
                value={defaultValue}
                onChange={(evt: any) => {
                    let value = evt.target.value;
                    if (value === '') {
                        handleSelectedPhotographer(null);
                    } else {
                        let newPhotographer = availablePhotographers.find(
                            (photographer) => photographer.id === Number(value)
                        );
                        handleSelectedPhotographer(newPhotographer);
                    }
                }}
                input={
                    <StyledSelect inputProps={{ 'aria-label': 'favorite-photographer-select' }} />
                }
                MenuProps={{
                    PaperProps: {
                        sx: {
                            '&& .MuiMenuItem-root': {
                                padding: 2,
                                fontSize: '16px',
                                alignItems: 'center'
                            }
                        }
                    }
                }}
            >
                <MenuItem default value={''}>
                    {defaultOptionLabel}
                </MenuItem>
                {availablePhotographers
                    ? availablePhotographers.map((photographer) => (
                          <MenuItem key={photographer.id} value={photographer.id}>
                              {photographer.name}
                          </MenuItem>
                      ))
                    : null}
            </Select>
        </FormControl>
    );
};

export default PhotographerSelectFilter;
